import applyPioneerImg from "../../../../assests/images/pioneerForm.png";
import dutiesPioneerImg from "../../../../assests/images/pioneerDuties.png";
//import benefitsPioneerImg from "../../../../assests/images/pioneerBenefits.png";
import criteriaPioneerImg from "../../../../assests/images/pioneerCriteria.png";
// Become a SAMPELL Pioneer
// Duties
// Benefits
// Criteria

export const content = [
  {
    title: "DUTIES OF A SAMPELL PIONEER",
    id: "duties",
    image: dutiesPioneerImg,
    text: "YOU DESIGN, YOU TRY, YOU EVALUATE. TOGETHER WE MAKE IT HAPPEN.",
    textOne:
      "A SAMPELL PIONEER will be the first to design, test and evaluate SAMPELL products and services. On our online platform you enter your body measurments. " +
      "Afterwards you design your own hoodie according to your style and taste. We produce and ship the product to you. You try the product and take pictures of the fit. " +
      "We ask you to give us feedback about the quality, material, the online process and  the usability of our online platform. You also can submit your own ideas for design, " +
      "fabric colors, patterns, the website, marketing ideas and so on. We have several ways of collecting your feedback. You should feel comfortable with giving us your feedback " +
      "in the context of a video interview, a live interview, skype, phone interviews, written comments, pictures of you or a questionnaire. You also should be open to share your " +
      "background story on our platform and why you are interested in creating your own fashion. If all this is interesting for you, please feel free to submit your application. \n" +
      "\n"
  },
  {
    title: "BENEFITS FOR SAMPELL PIONEERS",
    image: criteriaPioneerImg,
    text: "PRODUCTS. LIFETIME PASS. MAURITIUS.",
    textOne:
      "We are looking for SAMPELL pioneers, who like the idea of committing to SAMPELL and of becoming an active part of our journey. Together with the SAMPELL pioneers, their feedback, " +
      "ideas and guidance we will create a unique success story. Since every SAMPELL pioneer commits himself with high trust in advance, we as well will committe to our SAMPELL pioneers. \n" +
      "Every SAMPELL pioneer can design a hoodie of their taste for no costs. We cover all costs for production and delivery. We grant a 100%-satisfaction-gurantee. If you don‘t like your hoodie " +
      "for whatever reason, you can exchange until it fits 100 %.",
    textTwo:
      "The first 100 hoodies for the SAMPELL pioneers will have a special certification on the lining.",
    textThree:
      "According to our business model SAMPELL pioneers can offer their hoodie design on our platform for sale including their own brand name.  " +
      "For every sold hoodie they will recieve the double of the share of the revenue, that a regular seller would recieve.  \n" +
      "After  one year of collaboration, we will evaluate the cooperation between the SAMPELL pioneers and SAMPELL. We will offer a lifetime pass for SAMPELL pioneers, " +
      "who showed a true committement. The lifetime pass gurantees a free SAMPELL product per year for the same " +
      "conditions as the hoodie in the first year. In addition a lifetime pass entitels the owner of a 50 % discount on SAMPELL products. " +
      "If we hit our business goals within the next 5 years, every owner of a lifetime pass will receive a voucher for a free all-in-travel to Mauritius to visit our production places, to collaborate on " +
      "a certain project  (not revealed yet) and of course to have fun and a great holiday.  "
  },
  {
    title: "APPLICATION CRITERIA",
    image: applyPioneerImg,
    text: "OPEN MINDED? CREATIVE? TOLERANT? WE MIGHT MATCH. CHECK IT OUT.",
    item1: "You like unique clothes.",
    item2: "You care for clothes of high quality for a fair price.",
    item3: "You wear hoodies.",
    item4: "You can relate to our approach of unisex fashion",
    item5: "You are tolerant and open minded.",
    item6: "You like design and creativity.",
    item7: "You speak German and/or English.",
    item8: "You like to communicate and share your ideas on Social Media.",
    item9:
      "You are open to share your SAMPELL experiences with our online community - for instance in the context of written comments, video interviews or pictures of you.",
    item10:
      "You care for fashion that is produced under fair circumstances for people and environment.",
    item11:
      "No age restriction. If you are under 18, we would like for your parents to agree, that you take part in our project."
  }
];



// WEBPACK FOOTER //
// ./src/components/Pages/Audition/Content/auditionTexts.js